const glyphArrowright = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4014.4 1616.998 4.4 8">
    <g transform="translate(-4128 1600.698)">
        <path d="M140.6,23.9l3.7-3.6-3.7-3.6.4-.4,4,4-4,4Z" transform="translate(-27)"/>
    </g>
</svg>`;
export { glyphArrowright };
const glyphBuildingblocks = `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <title>building-blocks</title>
    <path d="M25.2,16h3V30H2.2V4h14V7l7-7,9,9Zm-21,0h10V6H4.2Zm10,2H4.2V28h10Zm2-7v5h5Zm0,7V28h10V18Zm.47-9,6.53,6.54L29.73,9,23.2,2.46Z"/>
</svg>`;
export { glyphBuildingblocks };
const glyphExamples = `<svg width="16" height="16" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g id="Canvas">
<g id="Group">
<g id="Vector">
<path d="M 4 2.9L 5.6 3.8L 5 4.8L 3.4 3.9L 3.4 5.8L 2.3 5.8L 2.3 3.9L 0.6 4.8L -3.8147e-07 3.8L 1.7 2.9L 0.1 2L 0.7 1L 2.2 1.9L 2.2 2.38419e-08L 3.3 2.38419e-08L 3.3 1.9L 4.9 1L 5.5 2L 4 2.9Z" transform="translate(10.3999 1.09998)"/>
</g>
<g id="Vector_2">
<path d="M 4 2.9L 5.6 3.8L 5 4.8L 3.4 3.9L 3.4 5.8L 2.2 5.8L 2.2 3.9L 0.6 4.8L 4.76837e-08 3.8L 1.6 2.9L 4.76837e-08 2L 0.6 1L 2.2 1.9L 2.2 -1.90735e-07L 3.3 -1.90735e-07L 3.3 1.9L 4.9 1L 5.5 2L 4 2.9Z" transform="translate(1.19995 10.2)"/>
</g>
<g id="Vector_3">
<path d="M 0 8L 0 0L 8 0L 8 8L 0 8ZM 1 1L 1 7L 7 7L 7 1L 1 1ZM 14.4 13.1L 16 14L 15.4 15L 13.8 14.1L 13.8 16L 12.7 16L 12.7 14.1L 11 15.1L 10.4 14.1L 12 13.2L 10.4 12.3L 11 11.3L 12.6 12.2L 12.6 10.3L 13.7 10.3L 13.7 12.2L 15.3 11.3L 15.9 12.3L 14.4 13.1Z"/>
</g>
</g>
</g>
</svg>`;
export { glyphExamples };
const glyphGlobalnavbutton = `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <title>global-nav-button</title>
    <path d="M.2,10V8h32v2Zm0,8V16h32v2Zm0,8V24h32v2Z"/>
</svg>`;
export { glyphGlobalnavbutton };
const glyphPage = `<svg width="12" height="16" viewBox="0 0 12 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g id="Canvas">
<g id="Glyph">
<path d="M 4.28906 0L 14 0L 14 13.7109L 11.7109 16L 2 16L 2 2.28906L 4.28906 0ZM 13 13.2891L 13 1L 4.71094 1L 3 2.71094L 3 15L 11.2891 15L 13 13.2891Z" transform="translate(-2 0)"/>
</g>
</g>
</svg>`;
export { glyphPage };
const glyphTransparency = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="15" height="15">
<rect width="3" height="3" />
<rect transform="translate(6)" width="3" height="3" />
<rect transform="translate(12)" width="3" height="3" />
<rect transform="translate(0 6)" width="3" height="3" />
<rect transform="translate(6 6)" width="3" height="3" />
<rect transform="translate(12 6)" width="3" height="3" />
<rect transform="translate(0 12)" width="3" height="3" />
<rect transform="translate(6 12)" width="3" height="3" />
<rect transform="translate(12 12)" width="3" height="3" />
<rect transform="translate(3 3)" width="3" height="3" />
<rect transform="translate(9 3)" width="3" height="3" />
<rect transform="translate(3 9)" width="3" height="3" />
<rect transform="translate(9 9)" width="3" height="3" />
</svg>`;
export { glyphTransparency };
